import { Injectable } from '@angular/core';
import { ApiService } from '@app/shared/services/api.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private apiService: ApiService) {}

  getCurrentUser = () => this.apiService.post('/profile/my-profile');

  update = (userData: any) =>
    this.apiService.post('/profile/save-profile', userData);

  updatePersonalData = (data: any) =>
    this.apiService.post('/my/info/change', data);

  updateCredentials = (userData: any) =>
    this.apiService.put('/my/credentials', userData);
}
